import "./styles.scss";
import { HeroSection } from "./components/HeroSection";
import { IntroSection } from "./components/IntroSection";
import { OfferBarSection } from "./components/OfferBarSection";
import { FeaturesSection } from "./components/FeaturesSection";
import { IncludedSection } from "./components/IncludedSection";
import { WhySection } from "./components/WhySection";
import { BottomCtaSection } from "./components/BottomCtaSection";

export const FinancingPage = () => {
  return (
    <main className="financing-v2-page">
      <HeroSection />
      <hr className="section-divider" />
      <IntroSection />
      <OfferBarSection />
      <FeaturesSection />
      <IncludedSection />
      <WhySection />
      <BottomCtaSection />
    </main>
  );
};
